import React from "react";
import { Box, Paper, Typography } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import { useTimetables } from "frontend/src/domain/timetables";
import { useDevice } from "frontend/src/domain/devices";
export var DeviceInfo = function (_a) {
    var _b, _c, _d, _e;
    var id = _a.id;
    var device = useDevice(id);
    var timetables = useTimetables();
    var timetable = (_b = timetables.data) === null || _b === void 0 ? void 0 : _b.find(function (timetable) { var _a; return timetable.id === ((_a = device.data) === null || _a === void 0 ? void 0 : _a.timetableId); });
    return (React.createElement(Box, { component: Paper, p: 2 },
        React.createElement(Typography, { variant: "h5" }, "\u0418\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F"),
        React.createElement(Box, { mt: 2 },
            React.createElement(Typography, { variant: "caption" }, "\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435"),
            React.createElement(Typography, { variant: "h6" }, device.isLoading ? (React.createElement(Skeleton, { width: 100 })) : ((_d = (_c = device.data) === null || _c === void 0 ? void 0 : _c.title) !== null && _d !== void 0 ? _d : "Не выбрано"))),
        React.createElement(Box, { mt: 1 },
            React.createElement(Typography, { variant: "caption" }, "\u0421\u0435\u0442\u043A\u0430 \u0432\u0435\u0449\u0430\u043D\u0438\u044F"),
            React.createElement(Typography, { variant: "h6" }, device.isLoading ? (React.createElement(Skeleton, { width: 100 })) : ((_e = timetable === null || timetable === void 0 ? void 0 : timetable.title) !== null && _e !== void 0 ? _e : "Не выбрана")))));
};
